import React from "react";

import { filterStory } from "../../helper/api";
import StoryCard9 from "../../molecules/story-card9";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import Carousel from "../../atoms/carousel";
import Separator from "../../atoms/separator";

import "./single-card-slider.m.css";

const SingleCardSlider = ({ collection, index }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const allStories = filterStory(collection);

  if (!allStories.length) {
    return null;
  }

  let stories = allStories.splice(0, 7);

  return (
    <>
      <CollectionTitleHeader collection={collection} index={index} />
      <div styleName="border-wrapper">
        <div styleName="wrapper">
          <Carousel
            options={{
              slidesToShow: 1
            }}
            totalItems={stories.length}
            showBullets
            showArrows
          >
            {stories.map((item, index) => (
              <StoryCard9 story={item} key={index} />
            ))}
          </Carousel>
        </div>
        <Separator />
      </div>
    </>
  );
};

export default SingleCardSlider;
